module.exports = __webpack_public_path__ + "img/recovered.e90d4a1f.png";